import { Component, inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
  ValidationErrors,
  AbstractControl,
  ValidatorFn,
} from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Pagination } from '@app/shared/model';
import { ProfissionaisReportService } from '@app/features-modules/bolsa-de-profissionais/services/profissionais-report.service';
import {
  ProfissaoCatalogoService,
  EmpresaSectorService,
  ProfissionaisEnumService,
  EspecialidadeFuncaoService,
  ExperienciaProfissionalService,
} from '@app/features-modules/bolsa-de-profissionais/services';
import { ApiService } from '@core/providers/http';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { TableComponent } from '@app/shared/components/table/table.component';
import { TableModule } from 'primeng/table';
import { DatePickerModule } from 'primeng/datepicker';
import { TableColumn } from '../../../../shared/components/table/table.component';
import { EnumService } from '@app/features-modules/gestao-bolseiros/components/api/services';
import { forkJoin } from 'rxjs';
import { Toast } from 'primeng/toast';
import { InputNumberModule } from 'primeng/inputnumber';
import { AuthStore } from '@core/service/auth-store.service';

@Component({
  selector: 'app-report-profissionais',
  providers: [
    MessageService,
    ProfissionaisReportService,
    ApiService,
    EnumService,
    EmpresaSectorService,
    EspecialidadeFuncaoService,
    ProfissaoCatalogoService,
    ExperienciaProfissionalService,
    ProfissionaisEnumService,
  ],
  imports: [
    CommonModule,
    DataVoidComponent,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    Dialog,
    SelectModule,
    InputNumberModule,
    TableComponent,
    TableModule,
    DatePickerModule,
    Toast,
  ],
  templateUrl: './report-profissionais.component.html',
  styleUrls: ['./report-profissionais.component.scss'],
})
export class ReportProfissionaisComponent implements OnInit {
  formProfissional!: FormGroup;
  profissionais: any[] = [];
  pagination: Pagination<any> = new Pagination<any>({
    pageNumber: 1,
    pageSize: 10,
    totalRecords: 0,
    data: [],
  });
  totalProfissionais: number = 0;
  showModalProfissionais = false;
  carregando = false;
  appliedFiltersProfissionais: { label: string; value: string }[] = [];
  empreseSectorService = inject(EmpresaSectorService);
  enumService = inject(ProfissionaisEnumService);
  profissaoCatalogo = inject(ProfissaoCatalogoService);
  especialidadeFuncao = inject(EspecialidadeFuncaoService);
  experienciaProfissional = inject(ExperienciaProfissionalService);
  private auth = inject(AuthStore);

  // Dropdown options
  subSectorList = [
    { label: 'Recursos Minerais', value: 1 },
    { label: 'Petróleo e Gás', value: 2 },
  ];

  groupPersonList = [
    { label: 'Responsável', value: 1 },
    { label: 'Técnico', value: 2 },
    { label: 'Operário', value: 3 },
    { label: 'Administração e Serviços', value: 4 },
  ];
  especialidadeList: any[] = [];
  regimeList: any[] = [];
  habilitacaoList: any[] = [];
  estadoCAndidaturaList: any[] = [];
  experienciaList: any[] = [];
  estadoProfissionalList: any[] = [];
  profissaoList: any[] = [];
  // idadeOptions = Array.from({ length: 15 }, (_, i) => {
  //   const idade = 18 + i;
  //   return { label: idade.toString(), value: idade };
  // });
  empresaSectorList: any[] = [];
  nivelAcademicoOptions: any[] = [];

  columnsProfissionais: TableColumn[] = [
    { field: 'profissional', header: 'Nome Profissional', type: 'text' },
    { field: 'empresa', header: 'Empresa', type: 'text' },
    { field: 'especialidade', header: 'Especialidade', type: 'text' },
    {
      field: 'profissaoReferencia',
      header: 'Profissão Referência',
      type: 'text',
    },
    {
      field: 'experienciaProfissionalDescricao',
      header: 'Experiêcncia Profissional',
      type: 'text',
    },
    {
      field: 'habilitaçõesAcadémicoDescricao',
      header: 'Habilitação Académica',
      type: 'text',
    },
    { field: 'generoDescricao', header: 'Género', type: 'text' },
    { field: 'idade', header: 'Idade', type: 'text' },
  ];

  generoOptions = [
    { label: 'Masculino', value: 1 },
    { label: 'Femenino', value: 2 },
  ];

  titlleOptions = [
    {
      label: 'Relatório de Profissionais',
      value: 'Relatório de Profissionais',
    },
    {
      label: 'Relatório de Profissionais Activos',
      value: 'Relatório de Profissionais Activos',
    },
  ];

  constructor(
    private fb: FormBuilder,
    private profissionaisReportService: ProfissionaisReportService,
    private messageService: MessageService,
  ) { }

  ngOnInit() {
    if (this.auth.hasAny(['emitir_relatório_profissionais'])) {
      this.showModalProfissionais = false;
      this.formProfissional = this.fb.group({
        subsector: [null],
        ProfissaoReferencia: [null],
        grupWork: [null],
        especialidade: [null],
        regime: [null],
        habilitacaoAcademica: [null],
        anoExperiencia: [null],
        estadoCandidatura: [null],
        genero: [null],
        idadeMinima: [null],
        idadeMaxima: [null],
        empresaid: [null],
        IsEmpregado: [null],
        titulo: ['Relatório de Profissionais', Validators.required],
        profissional: [null],
        funcao: [null],
        contacto: [null],
      });

      this.formProfissional.controls['subsector'].valueChanges.subscribe(
        (value) => {
          this.profissaoList = [];
          if ([null, undefined, ''].includes(value)) {
            this.formProfissional.get('ProfissaoReferencia')?.setValue(null);
            return;
          }

          this.getAllProfissoes({
            SubSector: value,
            pageSize: 500,
          });
        },
      );

      this.loadDropdowns();
      this.getAllProfissoes();
      this.getAllEspecialidade();
      this.getAllEmpresaSector();
      this.loadDataProfissionais();
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Permissão Inválida',
        detail: 'Não tens permissão para efetuar esta acção',
        life: 3000,
      });
    }
  }

  validarIntervaloIdade(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const idadeMin = group.get('idadeMinima')?.value;
      const idadeMax = group.get('idadeMaxima')?.value;

      if (idadeMin != null && idadeMax != null && idadeMin > idadeMax) {
        return { idadeInvalida: true };
      }

      return null;
    };
  }

  getAllProfissoes(params: any = {}) {
    this.profissaoCatalogo
      .list({ ...params, pageSize: 500 })
      .subscribe((profissoes) => {
        this.profissaoList = profissoes.data.map((item: any) => ({
          label: item.descricao,
          value: item.id,
        }));
      });
  }

  getAllEspecialidade() {
    this.especialidadeFuncao
      .list({ pageSize: 100 })
      .subscribe((especialidade) => {
        this.especialidadeList = especialidade.data.map((item: any) => ({
          label: item.designacao,
          value: item.id,
        }));
      });
  }

  getAllEmpresaSector() {
    this.empreseSectorService
      .list({ pageSize: 100 })
      .subscribe((empresaSector) => {
        this.empresaSectorList = empresaSector.data.map((item: any) => ({
          label: item.nome,
          value: item.id,
        }));
      });
  }

  loadDropdowns() {
    forkJoin({
      nivelAcademico: this.enumService.getAllNivelHabilitacao(),
      estadoProfissional: this.enumService.getAllEstadoProfissional(),
      regime: this.enumService.getAllRegimeTrabalho(),
      AnoExperienciaEnum: this.enumService.getAllAnoExperiencia(),
      estadoCandidatura: this.enumService.getAllEstadoCandidatura(),
    }).subscribe((response) => {
      // Enums
      if (response.nivelAcademico?.data) {
        this.habilitacaoList = Object.entries(response.nivelAcademico.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value,
          }),
        );
      }
      if (response.estadoProfissional?.data) {
        this.estadoProfissionalList = Object.entries(
          response.estadoProfissional.data,
        ).map(([key, value]) => ({
          id: Number(key),
          label: value,
        }));
      }
      if (response.regime?.data) {
        this.regimeList = Object.entries(response.regime.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value,
          }),
        );
      }
      if (response.AnoExperienciaEnum?.data) {
        this.experienciaList = Object.entries(
          response.AnoExperienciaEnum.data,
        ).map(([key, value]) => ({
          id: Number(key),
          label: value,
        }));
      }
      if (response.estadoCandidatura?.data) {
        this.estadoCAndidaturaList = Object.entries(
          response.estadoCandidatura.data,
        ).map(([key, value]) => ({
          id: Number(key),
          label: value,
        }));
      }
    });
  }

  updateAppliedFiltersProfissionais() {
    const formValue = this.formProfissional.value;
    const filters: { label: string; value: string }[] = [];

    if (formValue.subsector) {
      const subsector = this.subSectorList.find(
        (s) => s.value === formValue.subsector,
      )?.label;
      filters.push({
        label: 'Subsector',
        value: subsector || formValue.subsector,
      });
    }
    if (formValue.grupWork) {
      const grupo = this.groupPersonList.find(
        (g) => g.value === formValue.grupWork,
      )?.label;
      filters.push({
        label: 'Grupo de Trabalho',
        value: grupo || formValue.grupWork,
      });
    }
    if (formValue.especialidade) {
      filters.push({ label: 'Especialidade', value: formValue.especialidade });
    }
    if (formValue.regime) {
      const regime = this.regimeList.find(
        (r) => r.value === formValue.regime,
      )?.label;
      filters.push({
        label: 'Regime de Trabalho',
        value: regime || formValue.regime,
      });
    }
    if (formValue.habilitacaoAcademica) {
      const habil = this.habilitacaoList.find(
        (h) => h.value === formValue.habilitacaoAcademica,
      )?.label;
      filters.push({
        label: 'Habilitação Acadêmica',
        value: habil || formValue.habilitacaoAcademica,
      });
    }
    if (formValue.anoExperiencia) {
      const experiencia = this.experienciaList.find(
        (e) => e.value === formValue.anoExperiencia,
      )?.value;
      filters.push({
        label: 'Experiência Profissional',
        value: experiencia || formValue.anoExperiencia,
      });
    }
    if (formValue.genero) {
      const genero = this.generoOptions.find(
        (g) => g.value === formValue.genero,
      )?.label;
      filters.push({ label: 'Gênero', value: genero || formValue.genero });
    }
    if (formValue.idadeMaxima) {
      filters.push({ label: 'Idade Máxima', value: formValue.idadeMaxima });
    }
    if (formValue.idadeMinima) {
      filters.push({ label: 'Idade Mínima', value: formValue.idadeMinima });
    }
    if (formValue.empresaid) {
      const entidade = this.empresaSectorList.find(
        (e) => e.value === formValue.empresaid,
      )?.label;
      filters.push({
        label: 'Empresa do Sector',
        value: entidade || formValue.empresaid,
      });
    }
    if (
      formValue.IsEmpregado !== '' &&
      formValue.IsEmpregado !== undefined &&
      formValue.IsEmpregado !== null
    ) {
      const isEmpregado = formValue.IsEmpregado;
      filters.push({
        label: 'Situação Profissional',
        value: isEmpregado ? 'Empregado' : 'Desempregado',
      });
    }
    if (formValue.estadoCandidatura) {
      const entidade = this.estadoCAndidaturaList.find(
        (e) => e.id === formValue.estadoCandidatura,
      )?.label;

      filters.push({
        label: 'Estado da Candidatura',
        value: entidade || formValue.estadoCandidatura,
      });
    }

    this.appliedFiltersProfissionais = filters;
  }

  onSubmitProfissional() {
    this.formProfissional.markAllAsTouched();
    if (this.formProfissional.valid) {
      this.pagination.pageNumber = 1;
      this.loadDataProfissionais();
      this.updateAppliedFiltersProfissionais();
      this.showModalProfissionais = false;
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Por favor, preencha os campos obrigatórios do formulário.',
        life: 3000,
      });
    }
  }

  limparFiltrosProfissionais() {
    this.formProfissional.reset({
      titulo: 'Relatório de Profissionais',
      subsector: null,
      ProfissaoReferencia: null,
      grupWork: null,
      especialidade: null,
      regime: null,
      habilitacaoAcademica: null,
      anoExperiencia: null,
      estadoCandidatura: null,
      genero: null,
      idadeMinima: null,
      idadeMaxima: null,
      empresaid: null,
      IsEmpregado: null,
    });
    this.appliedFiltersProfissionais = [];
    this.pagination.pageNumber = 1;
    this.loadDataProfissionais();
    this.showModalProfissionais = false;
    this.messageService.add({
      severity: 'info',
      summary: 'Filtros Reiniciados',
      detail: 'Parâmetros de pesquisa restaurados para o padrão.',
      life: 2500,
    });
  }

  emitirPdfComFiltros() {
    this.formProfissional.markAllAsTouched();
    if (this.formProfissional.valid) {
      this.downloadPDFProfissional();
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Preencha os campos obrigatórios para exportar o PDF.',
        life: 3000,
      });
    }
  }

  emitirExcelComFiltros() {
    this.formProfissional.markAllAsTouched();
    if (this.formProfissional.valid) {
      this.downloadExcelProfissional();
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Preencha os campos obrigatórios para exportar o Excel.',
        life: 3000,
      });
    }
  }

  loadDataProfissionais(queryParams?: any) {
    this.carregando = true;
    const reportParams = this.buildReportParams();
    const params = {
      ...reportParams,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 10,
      OrderBy: queryParams?.OrderBy || 'id desc',
    };
    console.log('Params enviados para filtrar profissionais:', params);
    this.profissionaisReportService.filtrarProfissionais(params).subscribe({
      next: (res) => {
        this.carregando = false;
        this.pagination = new Pagination<any>().deserialize(res);
        const total = res.totalRecords ?? this.pagination.data?.length ?? 0;
        this.pagination.totalRecords = total;
        this.pagination.pageSize = res.pageSize ?? this.pagination.pageSize ?? 10;
        this.pagination.pageNumber = res.pageNumber ?? this.pagination.pageNumber ?? 1;
        this.pagination.totalPages =
          res.totalPages ?? Math.ceil(total / (this.pagination.pageSize || 10));
        this.profissionais = res.data || [];
        this.totalProfissionais = total;

        if (total > 0) {
          this.messageService.add({
            severity: 'success',
            summary: 'Relatório Emitido',
            detail: `${total} profissional(is) encontrado(s).`,
            life: 3000,
          });
        } else {
          this.messageService.add({
            severity: 'info',
            summary: 'Pesquisa Concluída',
            detail: 'Nenhum profissional encontrado com os filtros informados.',
            life: 3500,
          });
        }
      },
      error: (err) => {
        this.carregando = false;
        this.totalProfissionais = 0;
        this.profissionais = [];
        console.error('Erro ao consultar profissionais:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro na Consulta',
          detail: 'Não foi possível carregar os dados dos profissionais. Verifique os filtros ou tente novamente.',
          life: 4000,
        });
      },
    });
  }

  onPageChange(event: any) {
    const page =
      event.page !== undefined
        ? event.page + 1
        : Math.floor((event.first ?? 0) / (event.rows ?? this.pagination.pageSize ?? 10)) + 1;
    this.pagination.pageNumber = page;
    this.pagination.pageSize = event.rows ?? this.pagination.pageSize ?? 10;
    this.loadDataProfissionais();
  }

  /**
   * Constrói o objeto de parâmetros a partir dos filtros preenchidos no formulário.
   * Apenas serão enviados campos que possuem algum valor definido. Alguns campos
   * são renomeados para manter compatibilidade com os parâmetros da API de
   * relatórios (e.g. anoExperiencia → experienciaProfissional).
   */
  private buildReportParams(): any {
    const form = this.formProfissional.value;
    const params: any = {};

    // Mapear filtros básicos
    if (
      form.subsector !== null &&
      form.subsector !== undefined &&
      form.subsector !== ''
    ) {
      params.subsector = form.subsector;
    }
    if (
      form.ProfissaoReferencia !== null &&
      form.ProfissaoReferencia !== undefined &&
      form.ProfissaoReferencia !== ''
    ) {
      params.ProfissaoReferencia = form.ProfissaoReferencia;
    }
    if (
      form.grupWork !== null &&
      form.grupWork !== undefined &&
      form.grupWork !== ''
    ) {
      params.grupWork = form.grupWork;
    }
    if (
      form.especialidade !== null &&
      form.especialidade !== undefined &&
      form.especialidade !== ''
    ) {
      params.especialidade = form.especialidade;
    }
    if (
      form.regime !== null &&
      form.regime !== undefined &&
      form.regime !== ''
    ) {
      params.regime = form.regime;
    }
    if (
      form.habilitacaoAcademica !== null &&
      form.habilitacaoAcademica !== undefined &&
      form.habilitacaoAcademica !== ''
    ) {
      // Ajuste no nome do campo para compatibilidade com API anterior
      params.habilitacoessAcademico = form.habilitacaoAcademica;
    }
    if (
      form.anoExperiencia !== null &&
      form.anoExperiencia !== undefined &&
      form.anoExperiencia !== ''
    ) {
      // Ajuste de nomenclatura
      params.experienciaProfissional = form.anoExperiencia;
    }
    if (
      form.estadoCandidatura !== null &&
      form.estadoCandidatura !== undefined &&
      form.estadoCandidatura !== ''
    ) {
      params.estadoCandidatura = form.estadoCandidatura;
    }
    if (
      form.genero !== null &&
      form.genero !== undefined &&
      form.genero !== ''
    ) {
      params.genero = form.genero;
    }
    if (
      form.idadeMinima !== null &&
      form.idade !== undefined &&
      form.idadeMinima !== ''
    ) {
      params.idadeMinima = form.idadeMinima;
    }
    if (
      form.idadeMaxima !== null &&
      form.idadeMaxima !== undefined &&
      form.idadeMaxima !== ''
    ) {
      params.idade = form.idadeMaxima;
    }
    if (
      form.empresaid !== null &&
      form.empresaid !== undefined &&
      form.empresaid !== ''
    ) {
      params.empresaid = form.empresaid;
    }
    if (
      form.IsEmpregado !== null &&
      form.IsEmpregado !== undefined &&
      form.IsEmpregado !== ''
    ) {
      params.IsEmpregado = form.IsEmpregado;
    }
    if (
      form.titulo !== null &&
      form.titulo !== undefined &&
      form.titulo !== ''
    ) {
      params.titulo = form.titulo;
    }
    if (
      form.profissional !== null &&
      form.profissional !== undefined &&
      form.profissional !== ''
    ) {
      params.profissional = form.profissional;
    }
    if (
      form.funcao !== null &&
      form.funcao !== undefined &&
      form.funcao !== ''
    ) {
      // Mapear para cargoFuncao por compatibilidade
      params.cargoFuncao = form.funcao;
    }
    if (
      form.contacto !== null &&
      form.contacto !== undefined &&
      form.contacto !== ''
    ) {
      params.contacto = form.contacto.toString();
    }
    return params;
  }

  downloadExcelProfissional() {
    const params = this.buildReportParams();

    this.profissionaisReportService.sendProfissionaisExcel(params).subscribe(
      (response: Blob) => {
        const blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Relatorio-Profissionais.xlsx';
        link.click();
        window.URL.revokeObjectURL(url);
      },
      (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao exportar relatório.',
          life: 3000,
        });
      },
    );
  }

  downloadPDFProfissional() {
    const params = this.buildReportParams();
    // Para o relatório PDF, não enviamos o array completo de profissionais. A API
    // agora gera o relatório internamente com base apenas nos filtros.

    this.profissionaisReportService.sendProfissionaisPDF(params).subscribe(
      (response: Blob) => {
        const blob = new Blob([response], {
          type: 'application/pdf',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Relatorio-Profissionais.pdf';
        link.click();
        window.URL.revokeObjectURL(url);
      },
      (error) => {
        console.error('Erro ao exportar relatório:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao exportar relatório.',
          life: 3000,
        });
      },
    );
  }
}
